
  import Vue from 'vue'
  import TenantService from '@/services/TenantService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'TenantDeleteDialog',
    props: ['tenant'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading : false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmRestore() {
        this.loading = true;
      
        TenantService.restoreTenant(this.tenant.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('successRestore') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.$emit("restore", this.tenant);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('errorRestore') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
